'use client';

import React, { Fragment, useEffect, useState } from 'react';
import { JobGroups, useJobs } from '@gate-js/react';
import { TabGroup, TabList, TabPanels } from '@headlessui/react';
import classNames from 'classnames';
import { GroupContent, GroupTrigger } from './Groups';
import GateJobListNonEmptyWrapper from './GateJobListNonEmptyWrapper';
import {
	getTabListClasses, getTabListWrapperClasses, getTabPanelsWrapperClasses, getTabsWrapClasses,
} from './tabHelpers';

export default function GroupedJobListWrapper({
	tabColor, activeTabColor, tabBackground, activeTabBackground, tabBorderColor, tabBorderWidth, tabRounded,
	tabsAlign, tabsStyle = 'underline', tabsLayout = 'tabs',
	allTabLabel, showAllTab, emptyListText, children, className, style,
}) {
	const { jobs } = useJobs();

	const [selectedIndex, setSelectedIndex] = useState(0);

	useEffect(() => {
		setSelectedIndex(0);
	}, [jobs]);

	const tabProps = {
		tabColor, activeTabColor, tabBackground, activeTabBackground, tabBorderColor, tabBorderWidth, tabRounded, tabsStyle, tabsLayout,
	};

	if (jobs.length) {
		return (
			<>
				<GateJobListNonEmptyWrapper placeholder={emptyListText}>
					<TabGroup
						selectedIndex={selectedIndex}
						onChange={(newIndex) => setSelectedIndex(newIndex)}
						className={classNames('h-full', getTabsWrapClasses(tabsLayout))}
					>
						<div
							className={getTabListWrapperClasses(tabsLayout, tabsStyle)}
							style={tabsLayout === 'sidebar' || tabsStyle === 'background' ? undefined : { borderColor: tabColor }}
						>
							<TabList
								className={getTabListClasses(tabsLayout, tabsAlign)}
								aria-label="Tabs"
							>
								<JobGroups
									renderGroup={(props) => (
										<GroupTrigger
											{...props}
											{...tabProps}
										/>
									)}
									as={Fragment}
								/>
								{showAllTab && (
									<GroupTrigger value="all" label={allTabLabel} {...tabProps} />
								)}
							</TabList>
						</div>
						<TabPanels className={getTabPanelsWrapperClasses(tabsLayout)}>
							<JobGroups renderGroup={(props) => <GroupContent {...props} className={className} style={style} />} />
							<GroupContent className={className} style={style} />
						</TabPanels>
					</TabGroup>
				</GateJobListNonEmptyWrapper>
				{children}
			</>
		);
	}

	 return (
		<div className="space-y-4 max-w-4xl mx-auto">
			<p>{emptyListText}</p>
			{children}
		</div>
	);
}
